var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseFormV2',{ref:"baseForm",attrs:{"modelClass":_vm.ClientAppSettingKind,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }